if not App.angularApp?
    return

App.angularApp.directive 'mfDatepicker', () ->
    return {
        link: (scope, ele, attrs) ->
            ele.datepicker
                beforeShow: (input, instance) =>
                    $('#bs2-container').append($('#ui-datepicker-div'))
    }
